"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

if (document.getElementById('vue-application')) {
  new Vue({
    el: '#vue-application',
    propsData: _objectSpread({}, document.getElementById("vue-application").dataset),
    props: {
      sitekey: {
        type: String,
        "default": ''
      }
    },
    data: function data() {
      return {
        grecaptcha_sitekey: '',
        form: {
          name: '',
          lastname: '',
          email: '',
          message: '',
          job: '',
          cv: '',
          letter: '',
          rgpd: '',
          grecaptcha_token: ''
        },
        errors: {
          name: '',
          lastname: '',
          email: '',
          message: '',
          job: '',
          cv: '',
          letter: '',
          rgpd: '',
          grecaptcha_token: ''
        },
        success: false,
        lang: 'fr',
        errorMessageFileSize: null,
        errorMessageInputRequired: null,
        labelCv: null,
        labelLetter: null
      };
    },
    mounted: function mounted() {
      this.labelCv = this.$refs.labelCv.textContent;
      this.labelLetter = this.$refs.labelLetter.textContent;
      this.lang = this.$refs.formapplication.dataset.lang;
      window.recaptchaCallback = this.recaptchaCallback;
      this.form.job = document.querySelector('input[name="job"]').value;
      this.grecaptcha_sitekey = this.sitekey;
      this.errorMessageFileSize = this.lang === 'fr' ? 'Le fichier doit être inférieur à 3mo' : 'The file must be less than 3mb';
      this.errorMessageInputRequired = this.lang === 'fr' ? 'Ce champ est requis' : 'This field is required';
    },
    methods: {
      recaptchaCallback: function recaptchaCallback() {
        this.$set(this.form, 'grecaptcha_token', grecaptcha.getResponse());
        document.querySelector('.js-send-application').removeAttribute('disabled');
      },
      check: function check() {
        if (this.$refs.formapplication.checkValidity()) {
          return true;
        } else {
          this.$refs.formapplication.reportValidity();
          return false;
        }
      },
      updateCV: function updateCV(event) {
        if (event.target.files[0].size < 3145728) {
          this.errors.cv = '';
          this.form.cv = event.target.files[0];
          event.target.nextElementSibling.textContent = event.target.files[0].name;
        } else {
          this.errors.cv = this.errorMessageFileSize;
        }
      },
      updateLetter: function updateLetter(event) {
        if (event.target.files[0].size < 3145728) {
          this.errors.letter = '';
          this.form.letter = event.target.files[0];
          event.target.nextElementSibling.textContent = event.target.files[0].name;
        } else {
          this.errors.letter = this.errorMessageFileSize;
        }
      },
      resetErrors: function resetErrors() {
        this.errors = {
          name: '',
          lastname: '',
          email: '',
          message: '',
          job: '',
          cv: '',
          letter: '',
          rgpd: '',
          grecaptcha_token: ''
        };
      },
      getErrors: function getErrors(errors) {
        var data = {};
        var err = errors.response.data.data.params;

        if (Array.isArray(err)) {
          var name = err[0];
          this.getFirstError(name);

          var _iterator = _createForOfIteratorHelper(err),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var error = _step.value;
              data[error] = this.errorMessageInputRequired;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return data;
        } else {
          var _name = Object.keys(err)[0];
          this.getFirstError(_name);
          return Object.assign(this.errors, errors.response.data.data.params);
        }
      },
      getFirstError: function getFirstError(name) {
        var domRect = document.getElementsByName(name)[0].getBoundingClientRect();
        window.scroll({
          top: domRect.top + window.scrollY - 100,
          left: 0,
          behavior: "smooth"
        });
      },
      submitForm: function submitForm(e) {
        var _this = this;

        e.preventDefault();
        grecaptcha.ready(function () {
          grecaptcha.execute(_this.grecaptcha_sitekey, {
            action: 'contact'
          }).then(function (token) {
            _this.form.grecaptcha_token = token;

            _this.sendApplicationForm();
          });
        });
      },
      sendApplicationForm: function sendApplicationForm() {
        var _this2 = this;

        this.resetErrors();

        if (this.check()) {
          var formData = new FormData();
          Object.keys(this.form).forEach(function (key) {
            if (_this2.form[key]) {
              formData.append(key, _this2.form[key]);
            }
          });
          axios.request({
            method: 'POST',
            url: "/wp-json/vq/v1/contact",
            data: formData,
            headers: {
              'content-type': 'multipart/form-data'
            }
          }).then(function (response) {
            _this2.success = true;
            _this2.form = {
              name: '',
              email: '',
              message: '',
              cv: '',
              letter: '',
              grecaptcha_token: ''
            };
            _this2.$refs.labelCv.textContent = _this2.labelCv;
            _this2.$refs.labelLetter.textContent = _this2.labelLetter;
            _this2.$refs.fileLetter.value = null;
            _this2.$refs.fileCv.value = null;
            setTimeout(function () {
              return _this2.success = false;
            }, 5000);
          })["catch"](function (error) {
            console.log('error', error);
            _this2.errors = _this2.getErrors(error);
          });
        }
      }
    }
  });
}

; // Clickable button after recaptcha

function recaptchaCallbackJob() {
  console.log('here');
  document.querySelector('.js-send-application').removeAttribute('disabled');
}